<div class="auth-main">
    <div class="auth-main__content">
        <img
            class="auth-main__mobile-logo"
            src="./assets/icons/auth/brand-logo.svg"
            alt="Логотип"
        />
        <div class="auth-main__title">
            <img
                src="./assets/icons/auth/back.svg"
                (click)="backToLogin()"
                alt=""
            />
            <span>Документы на подпись</span>
        </div>
        <p class="auth-main__subtitle">
            Здравствуйте, {{ patient?.firstName }}! Для продолжения прочитайте и
            подпишите документы
        </p>
        <div *ngIf="isLoading">
            <loader type="page" message="Загружаем ..."></loader>
        </div>
        @for (contract of contractList; track contract.id) {
            <div class="docs-to-sign" *ngIf="!isLoading">
                <span
                    class="docs-to-sign__name"
                    (click)="clickContract(contract.id)"
                    >{{ contract.text }}</span
                >
                <button
                    class="docs-to-sign__button"
                    type="submit"
                    [disabled]="contract.mark"
                    (click)="goSignature(contract.id)"
                >
                    Подписать
                </button>
            </div>
        }
        <div class="error-message" *ngIf="errorMessage">
            {{ errorMessage }}
        </div>
    </div>
    <div class="auth-main__img">
        <img class="img-logo" src="./assets/icons/auth/brand-logo.svg" alt="" />
        <img
            class="img-doctor"
            src="./assets/icons/auth/signing-illustration.svg"
            alt=""
        />
    </div>
</div>

<!-- <div>
    <div *ngIf="dogList.length > 0; else loader">
        <div class="cls-auth-dog-title">
            Здравствуйте, {{ patient?.firstName }}
        </div>
        <div class="cls-auth-dog-title slow-ascent">
            Прочитайте и подпишите документы для продолжения:
        </div>

        <div
            class="row cls-auth-dog-list"
            *ngFor="let dog of dogList"
            on-mouseover="onHoverDog(dog.id)"
            on-mouseout="onMouseout(dog.id)"
            [ngClass]="{
                'cls-hoverDog': dog.id == dogHoverId,
                'cls-NotHoverDog': dogHoverId == 0,
                'cls-hoverNotDog': dogHoverId > 0 && dog.id != dogHoverId
            }"
        >
            <span class="col-md-8" (click)="clickDog(dog.id)">{{
                dog.text
            }}</span>
            <button
                class="btn btn-lg cls-btn cls-btn-auth cls-btn-sig col-md-4"
                type="submit"
                [disabled]="loading || !disableDog(dog.id)"
                (click)="goSignature(dog.id)"
            >
                Подписать
            </button>
        </div>

        <div class="cls-auth-dog-footer">
            <div class="cls-footer2" (click)="logout()" placeholder="Назад">
                <mat-icon
                    class="cls-icon-arrow-right"
                    svgIcon="arrow_left"
                    style="margin-right: 5px"
                ></mat-icon>
                <span>Назад</span>
            </div>
        </div>
    </div>
    <ng-template #loader>
        <div class="cls-auth-dog-loader">
            <loader type="component" message="Загружаем список документов..."> </loader>
        </div>
    </ng-template>
</div> -->
